import {Popover} from "@ui";
import PropTypes from "prop-types";
import {useCallback, useState} from "react";
import DropdownRender from "./DropdownRender";

const UserMenu = ({children, handleLogout}) => {
  const [visible, setVisible] = useState(false);
  const handleClose = useCallback(() => setVisible(false), []);

  const dropdownContent = (
    <DropdownRender
      handleLogout={handleLogout}
      dropdownStyle={{width: 175, padding: 0}}
      handleClose={handleClose}
    />
  );

  return (
    <Popover
      open={visible}
      styles={{body: {padding: 0}, root: {padding: 0}}}
      onOpenChange={setVisible}
      trigger="hover"
      content={dropdownContent}
      placement="bottomRight"
      arrow={false}
    >
      {children}
    </Popover>
  );
};

UserMenu.propTypes = {
  children: PropTypes.node,
  handleLogout: PropTypes.func,
};

export default UserMenu;
